module.exports = __webpack_public_path__ + "static/pipelineNoText-6865e8b4a9291e1352a7a6b3deaf541d.jpeg";